import {useEffect, useState} from "react";
import truncate from "html-truncate";
import Swal from "sweetalert2";
import {useNavigate} from "react-router-dom";
import {NoticeService} from "../../services/NoticeService";
import {GlobalRankingService} from "../../services/GlobalRankingService";
import {ServerService} from "../../services/ServerService";
import {NewLoading} from "../NewLoading";
import {Commons} from "../../helpers/Commons";
import {FormatDateTime} from "../../helpers/FormatDateTime";
import {LoggerUtils} from "../../helpers/LoggerUtils";

export const SelectServerPage = () => {
    const navigate = useNavigate();

    const {getNotices} = NoticeService();
    const {getFightPowerRanking} = GlobalRankingService();

    const [notices, setNotices] = useState([]);
    const [noticesLoading, setNoticesLoading] = useState(false);


    const [fightPowerRanking, setFightPowerRanking] = useState([]);
    const [fightPowerRankingLoading, setFightPowerRankingLoading] = useState(false);

    const [serverList, setServerList] = useState([]);
    const [serverListLoading, setServerListLoading] = useState(false);

    useEffect(() => {
        noticesLoader();
        rankingLoader();
        serverListLoader();
    }, []);

    const rankingLoader = async () => {
        const cachedRanking = localStorage.getItem("fightPowerRanking");
        if (cachedRanking) {
            setFightPowerRanking(JSON.parse(cachedRanking));
        } else {
            setFightPowerRankingLoading(true);
        }

        try {
            const response = await getFightPowerRanking(false, 5);
            setFightPowerRanking(response.data);
            localStorage.setItem("fightPowerRanking", JSON.stringify(response.data));
        } catch (err) {
            console.error("Erro ao buscar ranking:", err);
        }
        setFightPowerRankingLoading(false);
    };

    const noticesLoader = async () => {
        setNoticesLoading(true);
        try {
            const response = await getNotices(1, 1);
            setNotices(response.data);
        } catch (err) {
            console.error("Erro ao buscar notices:", err);
        }
        setNoticesLoading(false);
    };

    const serverListLoader = async () => {
        setServerListLoading(true);

        try {
            const response = await ServerService().getServerList();
            setServerList(response.data.data.servers);
        } catch (err) {
            console.error(err);
        }

        setServerListLoading(false);
    }

    const handlePlayGame = (serverId) => {
        try {
            Swal.showLoading();
            LoggerUtils().openGame(serverId);
        } catch (e) {
            Swal.fire("", "Não foi possível abrir o jogo, tente novamente.", "error");
        }
    };

    window.onGameOpened = async () => {
        Swal.close();
    };

    return (

        <div className="flex flex-col md:flex-row">
            <div className="w-full md:w-2/3 p-8">
                <div className="mb-8">
                    <div className="flex items-center mb-4">
                        <i className="fas fa-server text-blue-500 mr-2"></i>
                        <h2 className="text-xl font-semibold text-gray-800">Selecione seu Servidor</h2>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        {!serverListLoading ? (serverList.map((item, index) => (<div
                            className={`${item.online ? "server-card" : "server-maintoff-card"} bg-white p-4 rounded-lg shadow-sm cursor-pointer text-center`}>
                            <img alt="Profile photo" src={"https://i.imgur.com/BmuRvh8.jpeg"}
                                 className={"w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3"}></img>
                            <h3 className="font-bold text-lg text-gray-800">Servidor {index + 1}</h3>
                            <p className="text-sm text-gray-600 mb-2">{item.name}</p>
                            {item.online ? (<div
                                className="text-xs bg-green-100 text-green-600 rounded-full px-2 py-1 inline-block">Online
                            </div>) : (<div
                                className="text-xs bg-red-100 text-red-600 rounded-full px-2 py-1 inline-block">Manutenção
                            </div>)}
                            {/*<div className="mt-3">*/}
                            {/*    <span className="text-xs text-gray-500">Jogadores: 1,245</span>*/}
                            {/*</div>*/}
                            {item.online ? (<button onClick={() => handlePlayGame(item.id)}
                                                    className="btn-primary w-full mt-3 py-2 px-4 text-white font-medium rounded-lg">
                                Jogar <i className="fas fa-play ml-1"></i>
                            </button>) : (<button
                                className="btn-orange w-full mt-3 py-2 px-4 text-white font-medium rounded-lg">
                                Novidades <i className="fas fa-info ml-1"></i>
                            </button>)}
                        </div>))) : (<div>
                            <NewLoading></NewLoading>
                        </div>)}
                    </div>
                </div>

                {!Commons().isLauncherAgent() ? (<div className="mb-8">
                    <div className="flex items-center mb-4">
                        <i className="fas fa-download text-blue-500 mr-2"></i>
                        <h2 className="text-xl font-semibold text-gray-800">Download do Jogo</h2>
                    </div>

                    <div className="bg-gray-50 p-4 rounded-lg">
                        <p className="text-gray-700 mb-4">Baixe o cliente do jogo para melhor desempenho
                            e
                            experiência completa:</p>

                        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
                            <div
                                className="download-card bg-white p-3 rounded-lg shadow-sm cursor-pointer text-center">
                                <div
                                    className="bg-blue-100 text-blue-600 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-2">
                                    <i className="fab fa-windows text-xl"></i>
                                </div>
                                <h3 className="font-medium text-sm text-gray-800 mb-2">Windows</h3>
                                <a href={process.env.REACT_APP_DOWNLOAD_URL_WINDOWS} target={"_blank"}
                                   className="text-xs bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded mt-2">
                                    Download
                                </a>
                            </div>

                            <div
                                className="download-card bg-white p-3 rounded-lg shadow-sm cursor-pointer text-center">
                                <div
                                    className="bg-gray-100 text-gray-600 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-2">
                                    <i className="fab fa-apple text-xl"></i>
                                </div>
                                <h3 className="font-medium text-sm text-gray-800 mb-2">macOS</h3>
                                <a href={process.env.REACT_APP_DOWNLOAD_URL_MACOS} target={"_blank"}
                                   className="text-xs bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded mt-2">
                                    Download
                                </a>
                            </div>

                            <div
                                className="download-card bg-white p-3 rounded-lg shadow-sm cursor-pointer text-center">
                                <div
                                    className="bg-orange-100 text-orange-600 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-2">
                                    <i className="fab fa-linux text-xl"></i>
                                </div>
                                <h3 className="font-medium text-sm text-gray-800 mb-2">Linux</h3>
                                <a href={process.env.REACT_APP_DOWNLOAD_URL_LINUX} target={"_blank"}
                                   className="text-xs bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded mt-2">
                                    Download
                                </a>
                            </div>

                            <div
                                className="download-card bg-white p-3 rounded-lg shadow-sm cursor-pointer text-center">
                                <div
                                    className="bg-green-100 text-green-600 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-2">
                                    <i className="fab fa-android text-xl"></i>
                                </div>
                                <h3 className="font-medium text-sm text-gray-800 mb-2">Android</h3>
                                <a href={process.env.REACT_APP_DOWNLOAD_URL_ANDROID} target={"_blank"}
                                   className="text-xs bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded mt-2">
                                    Download
                                </a>
                            </div>

                            <div
                                className="download-card bg-white p-3 rounded-lg shadow-sm cursor-pointer text-center">
                                <div
                                    className="bg-gray-100 text-gray-600 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-2">
                                    <i className="fab fa-app-store-ios text-xl"></i>
                                </div>
                                <h3 className="font-medium text-sm text-gray-800 mb-2">iOS</h3>
                                <a href={process.env.REACT_APP_DOWNLOAD_URL_IOS} target={"_blank"}
                                   className="text-xs bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded mt-2">
                                    Download
                                </a>
                            </div>
                        </div>
                    </div>
                </div>) : (<></>)}
            </div>

            <div className="w-full md:w-1/3 bg-gray-50 p-6">
                <div className="mb-8">
                    <div className="flex items-center mb-4">
                        <i className="fas fa-newspaper text-blue-500 mr-2"></i>
                        <h3 className="text-xl font-semibold text-gray-800">Última nóticia</h3>
                    </div>

                    <div className="space-y-4">
                        {!noticesLoading ? (notices.map((item) => (
                            <div className="news-item bg-white p-4 rounded-lg shadow-sm cursor-pointer"
                                 onClick={() => navigate(`/showNotice/${item.id}`)}>
                                <div className="flex items-start">
                                    <div className="bg-blue-100 text-blue-500 p-2 rounded-full mr-3">
                                        <i className="fa-solid fa-bullhorn"></i>
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-gray-800">{item.title}</h4>
                                        <p
                                            className="text-sm text-gray-600 mt-1"
                                            dangerouslySetInnerHTML={{__html: truncate(item.content, 140)}}
                                        />

                                        <span
                                            className="text-xs text-gray-400 mt-1 block">{FormatDateTime(item.created_at)}</span>
                                    </div>
                                </div>
                            </div>))) : (<NewLoading></NewLoading>)}
                    </div>
                </div>

                <div>
                    <div className="flex items-center mb-4">
                        <i className="fas fa-trophy text-blue-500 mr-2"></i>
                        <h3 className="text-xl font-semibold text-gray-800">Ranking Global</h3>
                    </div>

                    {!fightPowerRankingLoading ? (
                        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                            <div className="grid grid-cols-3 bg-gray-100 text-gray-700 font-medium text-sm">
                                <div className="py-2 px-4">Jogador</div>
                                <div className="py-2 px-4">Poder</div>
                            </div>

                            <div className="divide-y divide-gray-200">
                                {fightPowerRanking.map((item) => (<div
                                    className="rank-item grid grid-cols-3 items-center hover:bg-gray-50">
                                    <div className="py-3 px-4 flex items-center">
                                        <div
                                            className="rank-number w-6 h-6 rounded-full bg-blue-500 text-white flex items-center justify-center text-xs font-bold mr-2">{item.rank}
                                        </div>
                                        <span
                                            className="text-sm font-medium">{item.character_name.substring(0, 4)}...</span>
                                    </div>
                                    <div
                                        className="py-3 px-4 text-sm text-gray-600">{item.fight_power}</div>
                                </div>))}
                            </div>

                            <div className="bg-gray-50 px-4 py-3 text-right">
                                <button onClick={() => navigate('/globalranking')}
                                        className="text-sm text-blue-500 hover:text-blue-700 hover:underline">Ver
                                    ranking completo
                                </button>
                            </div>
                        </div>) : (<NewLoading></NewLoading>)}
                </div>
            </div>
        </div>

    )
};